import {Box, Typography, Grid} from "@mui/material";
import {ReactElement} from "react";

const EmptyPlaceholder = (props: any): ReactElement => {
  const {icon, message} = props;
  return (
    <Grid
      className="empty-content"
      container
      direction="column"
      alignItems="center"
      justifyContent="center"
    >
      {icon}
      <Box mt={2} className="empty-text">
        <Typography variant="h2" className="f20">
          {message}
        </Typography>
      </Box>
    </Grid>
  );
};

export default EmptyPlaceholder;
